<template>
  <div class="wrapper">
    <h3>交通运输部门免收到达离开武汉的退票手续费</h3>

    <div
      class="mzsm"
      style='margin: 30px 0px; color: rgb(152, 152, 152); font-family: "Microsoft YaHei", Arial; white-space: normal;'
    >
      2020-01-22 08:49 来源： 新华社
    </div>

    <p
      style='margin-top: 20px; margin-bottom: 0px; padding: 0px; word-break: break-word; overflow-wrap: break-word; font-family: "Microsoft YaHei", Arial; white-space: normal;'
    >
      新华社北京1月21日电（记者
      魏玉坤）记者21日从交通运输部获悉，在做好新型冠状病毒感染的肺炎疫情防控涉及交通运输的有关工作同时，为更好满足旅客诉求，交通运输部和国家铁路局、中国民航局及中国国家铁路集团有限公司21日晚决定，对选择铁路、公路、水路、民航等交通出行方式的旅客，免收其到达、离开武汉的客车票、船票、机票等的退票手续费。
    </p>
    <p
      style='margin-top: 20px; margin-bottom: 0px; padding: 0px; word-break: break-word; overflow-wrap: break-word; font-family: "Microsoft YaHei", Arial; white-space: normal; text-align: justify;'
    ></p>
    <p
      style='margin-top: 20px; margin-bottom: 0px; padding: 0px; word-break: break-word; overflow-wrap: break-word; font-family: "Microsoft YaHei", Arial; white-space: normal;'
    ></p>
    <p
      style='margin-top: 20px; margin-bottom: 0px; padding: 0px; word-break: break-word; overflow-wrap: break-word; font-family: "Microsoft YaHei", Arial; white-space: normal;'
    >
      铁路方面，自即时起至2020年1月24日24时止，在车站、12306网站等各渠道，已购买武汉出发和到达的各次列车火车票的旅客，自愿改变出行计划需退票的，铁路部门均不收取退票手续费，购买乘意险的一同办理。
    </p>
    <p
      style='margin-top: 20px; margin-bottom: 0px; padding: 0px; word-break: break-word; overflow-wrap: break-word; font-family: "Microsoft YaHei", Arial; white-space: normal; text-align: justify;'
    ></p>
    <p
      style='margin-top: 20px; margin-bottom: 0px; padding: 0px; word-break: break-word; overflow-wrap: break-word; font-family: "Microsoft YaHei", Arial; white-space: normal;'
    ></p>
    <p
      style='margin-top: 20px; margin-bottom: 0px; padding: 0px; word-break: break-word; overflow-wrap: break-word; font-family: "Microsoft YaHei", Arial; white-space: normal;'
    ></p>
    <p
      style='margin-top: 20px; margin-bottom: 0px; padding: 0px; word-break: break-word; overflow-wrap: break-word; font-family: "Microsoft YaHei", Arial; white-space: normal; text-align: center;'
    >
      公路、水路方面，各级交通运输部门全力确保春运安全畅通，明确对已经购买涉及武汉车、船票的旅客，当提出退票要求时，客运企业应当办理免费退票，不得收取任何费用。
    </p>
    <p
      style='margin-top: 20px; margin-bottom: 0px; padding: 0px; word-break: break-word; overflow-wrap: break-word; font-family: "Microsoft YaHei", Arial; white-space: normal; text-align: center;'
    >
      水运、公路、铁路都是枢纽，想绕开还是挺难的
    </p>
    <p
      style='margin-top: 20px; margin-bottom: 0px; padding: 0px; word-break: break-word; overflow-wrap: break-word; font-family: "Microsoft YaHei", Arial; white-space: normal; text-align: center;'
    ></p>

    <p
      style='margin-top: 20px; margin-bottom: 0px; padding: 0px; word-break: break-word; overflow-wrap: break-word; font-family: "Microsoft YaHei", Arial; white-space: normal;'
    ></p>
    <p
      style='margin-top: 20px; margin-bottom: 0px; padding: 0px; word-break: break-word; overflow-wrap: break-word; font-family: "Microsoft YaHei", Arial; white-space: normal;'
    >
      民航方面，要求各运输航空公司高度重视旅客服务工作，针对已经购买涉及武汉航班机票的旅客，如有退票要求，航空公司应当予以免费办理。
    </p>
    <p
      style='margin-top: 20px; margin-bottom: 0px; padding: 0px; word-break: break-word; overflow-wrap: break-word; font-family: "Microsoft YaHei", Arial; white-space: normal; text-align: justify;'
    ></p>

    <p>
      <br />
    </p>
  </div>
</template>

<script>
export default {};
</script>

<style lang="less" scoped>
.wrapper {
  padding: 20px;
  h3 {
    font-size: 18px;
    text-align: center;
  }
  img {
    max-width: 100% !important;
  }
}
</style>
